import { render } from "./StructuredListInput.vue?vue&type=template&id=6b0dc290&scoped=true"
import script from "./StructuredListInput.vue?vue&type=script&lang=js"
export * from "./StructuredListInput.vue?vue&type=script&lang=js"

import "./StructuredListInput.vue?vue&type=style&index=0&id=6b0dc290&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0dc290"]])

export default __exports__